<div class="banner-container rounded flex flex-col md:flex-row justify-start md:justify-center items-start md:items-center p-3 md:py-2.5 md:px-8 gap-6 md:gap-8"
    [ngClass]="{
       'relative z-0': !shouldStack(),
       'absolute top-3 left-4 right-4 -z-10': shouldStack()
     }">
    <div class="text-base flex flex-col md:flex-row gap-2">
        <span>Webinar: <b>Legal Action and Strategy Plan</b></span>
        <span>December 4th, 2025 – 10 AM PT</span>
    </div>
    <div class="flex items-center gap-3">
        <button class="bg-brand-gray_dark rounded px-2 py-1 whitespace-nowrap">
            <a href="https://avanacuso.com/webinar-finding-legal-counsel/#register"
                target="_blank" class="no-underline text-white">
                Register now
            </a>
        </button>
        <a href="https://avanacuso.com/webinar-finding-legal-counsel/" target="_blank"
            class="text-brand-gray_dark no-underline whitespace-nowrap">Learn more</a>
    </div>
</div>